import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { COMPANY } from "@/lib/constants";

export default function CtaBanner({
    title = "Bereit für ein Angebot?",
    subtitle = "Schnell anrufen oder Formular senden – wir melden uns in der Regel innerhalb eines Werktags zurück.",
}) {
    return (
        <section className="relative py-16 sm:py-20 border-t border-white/[0.06]">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="rounded-2xl border border-white/[0.10] bg-[rgba(14,20,31,0.78)] backdrop-blur-md p-6 sm:p-10 card-elevated flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
                    <div className="max-w-xl">
                        <h2 className="font-heading text-2xl sm:text-3xl font-semibold text-white">
                            {title}
                        </h2>
                        <p className="mt-3 text-[#C9D3E1] leading-relaxed">
                            {subtitle}
                        </p>
                    </div>
                    <div className="flex flex-col sm:flex-row gap-3 shrink-0">
                        <a
                            href={`tel:${COMPANY.phoneTel}`}
                            className="inline-flex items-center justify-center gap-2 px-5 h-12 rounded-xl bg-[#2EA8FF] text-[#07090C] font-medium hover:bg-[#7BD3FF] transition-colors btn-glow"
                        >
                            <Phone className="h-4 w-4" />
                            {COMPANY.phone}
                        </a>
                        <Link
                            to="/kontakt"
                            className="inline-flex items-center justify-center gap-2 px-5 h-12 rounded-xl border border-white/[0.14] text-[#F4F7FB] hover:border-[rgba(123,211,255,0.55)] hover:bg-[rgba(46,168,255,0.06)] transition-colors"
                        >
                            Angebot anfragen
                            <ArrowRight className="h-4 w-4" />
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}
